import React from 'react';
import { avatarColors } from '../../../mockups/Profile/profile_data';
import { GoHeartFill } from 'react-icons/go';
import { MdRemoveRedEye } from 'react-icons/md';
import { useSelector } from 'react-redux';

function ProjectContent({ project }) {
  const loading = useSelector((state) => state.projects.loading);
  const error = useSelector((state) => state.projects.error);

  if (loading) {
    return <p className="text-white p-6">Loading project...</p>;
  }
  
  if (error) {
    return <p className="text-red-500 p-6">Error: {error}</p>;
  }
  
  if (!project) {
    return <p className="text-white p-6">No project found.</p>;
  }

  return (
    <div className="my-12 text-white">
      <div
        style={{ backgroundColor: avatarColors[4] }}
        className="h-[230px] md:h-[350px] lg:h-[400px] w-full rounded-xl"
      />

      <div className="py-5">
        <h2 className="text-xl font-semibold">{project.name}</h2>
        <p className="text-sm my-2">By: {project.owner || 'Unknown owner'}</p>

        <p className="font-semibold text-white">Stage: {project.funding_stage}</p>

        <p className="my-5">
          <span className="font-semibold">Project Description:</span>
          {project.description}
        </p>

        <div className="flex my-5 space-x-12">
          <button className="flex items-center space-x-1">
            <GoHeartFill className="text-red-600 text-2xl" />
            <span>45</span>
          </button>
          <button className="flex items-center space-x-1">
            <MdRemoveRedEye className="text-blue-600 text-2xl" />
            <span>12</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProjectContent;
